module.exports = __webpack_public_path__ + "img/cc83a2b.png";